import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { LogLevels } from "../types/Log/LogLevels";

@Injectable({ providedIn: "root" })
export class EnvironmentService {
  env: any = environment;

  public getEnvironment(): any {
    return this.env;
  }

  public getShowDevEnvironmentFlag(): any {
    return this.env.showDevEnvironment;
  }

  public getDevVariables(): any {
    return this.env.envVar;
  }

  public getVersion(): string {
    return this.env.version;
  }

  public getBuild(): string {
    return this.env.build;
  }

  public getAdminPortalUrl(key: string): string {
    return this.env.config.urls.cloud.ajax[key];
  }

  public getServicesApiUrl(key: string): string {
    return this.env.config.urls.cloud.api[key];
  }

  public getServicesApiPrivateKey(): string {
    return this.env.config.apiPrivateKey;
  }

  public getGoogleMapsApiKey(): string {
    return this.env.config.googleMapsAPIKey;
  }

  public getPrintablesUrl(): string {
    return this.env.config.urls.printables;
  }

  public getLogLevel(): LogLevels {
    const logLevel = this.env?.envVar?.logLevel;
    return logLevel ? logLevel.toUpperCase() : "ERROR";
  }

  public getLogTransports(): string {
    return this.env?.envVar?.logTransports;
  }
}
